export const viMessages = {
  common: {
    back: 'Quay lại',
    continue: 'Tiếp tục',
    pleaseWait: 'Vui lòng đợi...',
    edit: 'Sửa',
    exit: 'Thoát',
    close: 'Đóng',
    notAnswered: '— Chưa trả lời',
    emptyValue: '---',
    backToSummary: 'Quay lại Tổng hợp',
    toSummary: 'Về Tổng hợp',
    toFinalSummary: 'Về Tổng hợp cuối',
    selectPlaceholder: 'Chọn...',
    selectRegion: 'Chọn khu vực...',
    selectIncome: 'Chọn mức thu nhập...',
    displayDescriptionPrefix: 'Mô tả hiển thị:',
    weightUnit: 'kg',
    viewFinalSummary: 'Xem Tổng hợp cuối',
    redo: 'Làm lại',
    start: 'Bắt đầu',
    resultPrefix: 'Kết quả:',
    supplementDetails: 'Bổ sung chi tiết',
    supplementDone: '✅ Đã bổ sung (Sửa)',
    takeQuiz: 'Làm trắc nghiệm',
    retakeQuiz: 'Làm lại trắc nghiệm',
    viewResultAndShare: 'Xem kết quả & chia sẻ',
    submitting: 'Đang gửi…',
    submittingData: 'ĐANG GỬI DỮ LIỆU...',
    confirmSubmit: 'XÁC NHẬN GỬI HỒ SƠ',
    join: 'THAM GIA',
    logout: 'Thoát',
  },

  logo: {
    dating: 'TÌM NGƯỜI YÊU/BẠN ĐỜI',
    quizPrefix: 'Date.',
    quizHighlight: 'Mut',
    quizSuffix: '.Vn',
  },

  progress: {
    introHint: 'Hãy điền thông tin nếu bạn thực sự muốn kết nối với một chàng trai như ý',
  },

  login: {
    title: 'Tham Gia / Đăng Nhập',
    titleQuiz: 'Tạo hồ sơ / Đăng nhập',
    quizHint: 'Đã làm quiz? Đăng ký để lưu kết quả và được ghép người phù hợp.',
    backToQuiz: 'Quay lại quiz',
    emailLabel: 'Email hoặc SĐT liên hệ',
    emailPlaceholder: 'Ví dụ: 0912345678/tenban@gmail.com',
    pinLabel: 'Mã PIN (Bảo mật hồ sơ)',
    pinPlaceholder: '******',
    tryQuizFirst: 'Thử quiz trước — không cần đăng ký',
  },

  steps: {
    step1: {
      title: 'BƯỚC 1: THÔNG TIN',
      privacyNote: 'Mọi thông tin của bạn đều được bảo mật an toàn.',
      fullName: 'Họ và tên',
      nickname: 'Nickname',
      dob: 'Ngày sinh',
      dobPlaceholder: 'DD/MM/YYYY (Ví dụ: 20/01/2000)',
      city: 'Tỉnh / Thành phố',
      address: 'Quận/Huyện & Địa chỉ cụ thể',
      addressPlaceholder: 'Ví dụ: Quận 1, Đường Lê Lợi...',
    },
    step2: {
      title: 'BƯỚC 2: CHÂN DUNG',
      height: 'Chiều cao (cm)',
      heightPlaceholder: '175',
      weight: 'Cân nặng (kg)',
      weightPlaceholder: '70',
      bodyType: 'Hình thể (Tạng người)',
      education: 'Trình độ học vấn',
      income: 'Thu nhập/tháng',
      job: 'Nghề nghiệp & Chức vụ hiện tại',
      jobPlaceholder: 'Ví dụ: Trưởng phòng IT của Ngân hàng ACB',
      currentStatus: 'Tình trạng hiện tại:',
      livingSpace: 'Không gian sống hiện tại:',
    },
    step3: {
      title: 'BƯỚC 3: BẢN SẮC',
      orientation: 'Xu hướng',
      role: 'Vai trò (Role)',
      comingOut: 'Mức độ Come out',
      relationship: 'Mối quan hệ tìm kiếm',
      personality: 'Tính cách nổi bật',
      pros: 'Điểm cộng',
      cons: 'Điểm trừ',
      substances: 'Chất kích thích',
    },
    step4: {
      title: 'BƯỚC 4: CHIỀU SÂU',
      energy: 'Năng lượng',
      lifestyle: 'Lối sống',
      hobbies: 'Sở Thích',
      loveLanguage: 'Ngôn ngữ tình yêu',
      futurePlans: 'Định hướng tương lai',
      futureKids: 'Quan điểm về con cái',
      financeShared: 'Quan điểm về tài chính chung',
      financeMindset: 'Tư duy về tiền bạc',
      sexView: 'Quan điểm về tình dục',
    },
    step5: {
      title: 'BƯỚC 5: TIÊU CHUẨN',
      partnerAge: 'Khoảng tuổi mong muốn của đối phương',
      partnerRole: 'Vai trò của đối phương',
      partnerBody: 'Hình thể lý tưởng',
      priority: 'Tiêu chí ưu tiên',
      redflag: 'Điều TUYỆT ĐỐI không chấp nhận',
      messageToAdmin: 'Điều quan trọng nhất bạn muốn nhắn gửi',
      messageToAdminPlaceholder:
        'Ưu điểm, sở thích đặc biệt của bạn hoặc hình mẫu lý tưởng bạn muốn kết nối',
    },
    step6: {
      title: 'Chặng 6: Xác thực uy tín hồ sơ',
      avatar: 'Hình ảnh cá nhân (Có thể chọn nhiều ảnh)',
      avatarUploading: 'Đang xử lý ảnh...',
      avatarUpload: '📸 Chạm để Chọn thêm ảnh',
      socialLink: 'Link Facebook / Instagram cá nhân',
      socialLinkPlaceholder: 'https://facebook.com/timnguoiyeu',
      idCard: 'Ảnh chụp CCCD (Mặt trước)',
      idCardSubtitle: 'Không bắt buộc — nếu gửi sẽ giúp xác minh chính chủ, chống lừa đảo.',
      idCardUploading: 'Đang xử lý ảnh...',
      idCardUploaded: '✅ Đã tải ảnh thành công',
      idCardUpload: '📸 Chạm để Chọn/Chụp ảnh',
    },
    step8: {
      title: 'BƯỚC 8: TÂM LÝ',
      description: 'Bổ sung thêm để Admin hiểu sâu hơn về trạng thái tâm lý và sự sẵn sàng của bạn.',
    },
    step9: {
      title: 'BƯỚC 9: THỰC TẾ CUỘC SỐNG',
      description: 'Vật nuôi, tôn giáo và sức khỏe — những yếu tố ảnh hưởng đến không gian sống chung.',
    },
    step10: {
      title: 'BƯỚC 10: TÌNH DỤC & SỨC KHỎE',
      description: 'Quan điểm và sở thích giường chiếu — thông tin được bảo mật tuyệt đối.',
    },
    step11: {
      title: 'BƯỚC 11: ÁP LỰC & RÀO CẢN',
      description: 'Mức độ ảnh hưởng của gia đình và xã hội đến cuộc sống tình cảm của bạn.',
    },
    step12: {
      title: 'BƯỚC 12: CÂU HỎI TỰ LUẬN',
      description:
        'Viết vài câu bằng lời của mình — để Admin hiểu rõ hơn phông văn hoá và cá tính của bạn.',
      answerPlaceholder: 'Hãy viết câu trả lời của bạn tại đây...',
    },
  },

  summary: {
    title: 'TỔNG HỢP HỒ SƠ',
    hint: 'Vui lòng kiểm tra kỹ các thông tin dưới đây. Bạn có thể bấm nút',
    hintEdit: '[Sửa]',
    hintSuffix: 'ở từng mục để điều chỉnh.',
    section1Title: '📌 1. Thông Tin Hành Chính',
    section1TitleShort: '📌 Thông tin',
    section2Title: '👤 2. Chân Dung & Nền Tảng',
    section2TitleShort: '👤 Chân dung',
    section3Title: '🌈 3. Bản Sắc & Tính Cách',
    section3TitleShort: '🌈 Bản sắc',
    section4Title: '🌌 4. Chiều Sâu & Lối Sống',
    section4TitleShort: '🌌 Lối sống',
    section5Title: '🎯 5. Tiêu Chuẩn Đối Phương',
    section5TitleShort: '🎯 Đối phương',
    section6Title: '📸 6. Xác Thực Uy Tín',
    section6TitleShort: '📸 Xác thực',
    section7Title: '🧩 7. Tính năng bổ sung & trắc nghiệm (không bắt buộc)',
    section7Description:
      'Làm trắc nghiệm nhanh để admin hiểu rõ bạn hơn; bạn có thể tải ảnh kết quả nếu muốn chia sẻ.',
    deepQuestionsTitle: '💬 Câu Hỏi Tìm Hiểu Sâu',
    deepQuestionsDescription:
      'Chia sẻ chi tiết hơn về thói quen sinh hoạt và quan điểm xử lý mâu thuẫn.',
    personalityQuizTitle: '🎭 Trắc Nghiệm Tính Cách Hẹn Hò',
    personalityQuizDescription:
      'Khám phá xem bạn thuộc nhóm tính cách nào khi yêu: Tinh tế, ấm áp hay lãng mạn?',
    frozenHeartTitle: '🧊 Trái tim băng giá',
    frozenHeartDescription: 'Giải mã lời nguyền độc thân — 10 câu, nhận thẻ Story để chia sẻ.',
    fullName: 'Họ Tên:',
    dob: 'Ngày Sinh:',
    contact: 'Liên Hệ:',
    address: 'Địa Chỉ:',
    heightWeight: 'Chiều Cao/Cân Nặng:',
    heightWeightValue: '{height}cm{weightPart}',
    weightPart: ' - {weight}kg',
    bodyType: 'Tạng Người:',
    education: 'Học Vấn:',
    job: 'Nghề Nghiệp:',
    income: 'Thu Nhập:',
    status: 'Tình Trạng:',
    orientationRole: 'Xu Hướng & Role:',
    comeOut: 'Come out:',
    seekingRelationship: 'Mối quan hệ tìm kiếm:',
    personalityTraits: 'Tính cách nổi bật:',
    pros: 'Ưu Điểm:',
    cons: 'Nhược Điểm:',
    substances: 'Chất Kích Thích:',
    energyLifestyle: 'Năng lượng & Lối sống:',
    kidsView: 'Quan điểm con cái:',
    hobbies: 'Sở thích:',
    loveLanguage: 'Ngôn ngữ tình yêu:',
    futurePlans: 'Định hướng tương lai:',
    finance: 'Quan điểm tài chính & Tiền bạc:',
    sexView: 'Quan điểm tình dục:',
    priority: 'Tiêu chí ưu tiên:',
    partnerPrefs: 'Gu Đối Phương (Tuổi, Role, Hình thể):',
    redflag: 'Redflag (Điều Tuyệt Đối Không Chấp Nhận):',
    message: 'Lời nhắn nhủ:',
    social: 'Mạng Xã Hội:',
    personalPhotos: 'Ảnh Cá Nhân:',
    idCardSecure: 'Ảnh CCCD (Bảo Mật):',
    idCardBadge: 'CCCD',
  },

  summaryFull: {
    title: 'TỔNG HỢP TOÀN DIỆN',
    hint: 'Kiểm tra lại toàn bộ thông tin. Bấm',
    hintEdit: '[Sửa]',
    hintSuffix: 'ở từng mục để chỉnh sửa.',
    psychTitle: '🧠 Tâm Lý & Cảm Xúc',
    psychTitleShort: '🧠 Tâm lý',
    practicalTitle: '🏠 Thực Tế Cuộc Sống',
    practicalTitleShort: '🏠 Thực tế',
    sexTitle: '❤️ Tình Dục & Sức Khỏe',
    sexTitleShort: '❤️ Tình dục',
    pressureTitle: '👥 Áp Lực & Rào Cản',
    pressureTitleShort: '👥 Áp lực',
    narrativeTitle: '✍️ Câu Hỏi Tự Luận EQ',
    narrativeTitleShort: '✍️ Tự luận',
    quizTitle: '🧩 Trắc Nghiệm',
    personalityQuizLabel: '🎭 Tính Cách Hẹn Hò',
    frozenHeartLabel: '🧊 Trái tim băng giá',
    backToFirstSummary: '← Quay về Tổng hợp đợt 1',
  },

  quiz: {
    heroTitle: 'Khám phá bản thân',
    heroDescription:
      'Hai bài quiz ngắn — không cần đăng ký. Làm xong có thể tải ảnh Story và chia sẻ nếu bạn thấy vừa ý.',
    heroNote: 'Giải trí & gợi mở, không thay tư vấn tâm lý.',
    loggedInAs: 'Đang đăng nhập:',
    viewProfile: 'Xem hồ sơ',
    createPrivateProfile: 'Muốn được ghép người phù hợp? Tạo hồ sơ kín',
    alreadyHaveProfile: 'Đã có hồ sơ — đăng nhập',
    saveQuizToProfile: 'Lưu kết quả quiz vào hồ sơ',
    backToQuizPage: '⬅️ Quay lại trang trắc nghiệm',
    frozenHeart: {
      title: 'Trái tim băng giá',
      description:
        'Giải mã lời nguyền độc thân — nhận tấm thẻ hồ sơ độc bản để flex hoặc thả thính Story.',
      meta: '10 câu · ~90 giây',
      decodeNow: 'Giải mã ngay',
    },
    personality: {
      title: 'Gu khi yêu',
      description:
        'Flex, thả thính hay chữa lành — xem bạn thuộc team CEO tình cảm, nam thần phủ sóng, gấu gia đình hay vitamin mặn mòi.',
      meta: '5 câu · khoảng 1 phút',
    },
    progress: 'Câu {current} / {total}',
    closeAriaLabel: 'Đóng',
    joinDating: 'Tham gia hẹn hò',
  },

  share: {
    nameField: {
      label: 'Tên hiển thị trên ảnh Story',
      placeholder: 'VD: Thành, N.V.Thành...',
      hint: 'Chỉ nickname / tên gọi ở nhà — không ghi họ tên đầy đủ',
      requiredHint: ' · Bắt buộc trước khi chia sẻ ảnh',
    },
    avatarPicker: {
      label: 'Ảnh đại diện trên card',
      ariaLabel: 'Ảnh đại diện trên card',
      personal: {
        title: 'Ảnh cá nhân',
        description: 'Dùng ảnh từ hồ sơ của bạn',
      },
      default: {
        title: 'Biểu tượng quiz',
        description: 'Dùng icon mặc định của kết quả',
      },
    },
    aspectPicker: {
      label: 'Tỉ lệ ảnh xuất',
      ariaLabel: 'Tỉ lệ ảnh xuất',
      story: {
        ratioLabel: '9:16',
        platformLabel: 'Story / Reels',
        exportLabel: '1080×1920',
      },
      feed: {
        ratioLabel: '3:4',
        platformLabel: 'Facebook / Instagram / Threads',
        exportLabel: '1080×1440',
      },
    },
    actions: {
      share: 'Chia sẻ',
      download: 'Tải về máy',
      generating: 'Đang tạo ảnh…',
      downloadWithSpec: 'Tải ảnh {ratio} ({exportLabel})',
      copyCaption: 'Copy caption chia sẻ',
      captionCopied: 'Đã copy caption',
      nativeShareHintPrefix: 'Chọn',
      nativeShareSave: 'Lưu ảnh',
      nativeShareGooglePhotos: 'Google Ảnh',
      nativeShareInstagram: 'Instagram',
      nativeShareHintSuffix: 'trong menu — không cần qua Downloads',
    },
    caption: {
      personalityQuizLabel: 'Gu khi yêu',
      singleQuizLabel: 'Trái tim băng giá',
      scoreFrozenHeart: 'nhiệt độ trái tim {temperature} ({temperatureLabel})',
      scorePersonality: 'khớp {percent}%, nhóm {typeKey}',
      template:
        'Mình vừa làm quiz "{quizLabel}" trên {siteName} — kết quả: {shareTitle} ({scoreLine}).\n"{shareHook}"\nThử xem bạn thuộc nhóm nào: {quizUrl}',
    },
    card: {
      personalityLabel: 'Gu khi yêu',
      singleLabel: 'Trái tim băng giá',
      frozenPercent: 'Đóng băng',
      temperature: 'Nhiệt độ:',
      qrSubtitlePersonality: 'Quét mã làm quiz ngay',
      qrSubtitleSingle: 'Giải mã lời nguyền độc thân',
      footerTagline: 'Tìm người yêu/Bạn đời',
      zodiacPrefix: 'Cung',
    },
  },

  alerts: {
    apiKeyNotConfigured: 'Hệ thống chưa được cấu hình API Key lưu ảnh. Vui lòng liên hệ Admin.',
    imageProcessFailed: 'Không thể xử lý ảnh, vui lòng thử lại.',
    imageProcessNetworkError: 'Không thể xử lý ảnh, vui lòng kiểm tra kết nối mạng.',
    genericError: 'Đã có lỗi xảy ra, vui lòng thử lại sau.',
    networkError: 'Đã có lỗi xảy ra, vui lòng kiểm tra kết nối mạng.',
    quizSavedLocally:
      'Kết quả quiz đã lưu trên máy bạn. Đăng ký email + PIN để gửi hồ sơ và được ghép người phù hợp!',
    shareNameRequired: 'Vui lòng nhập tên hiển thị trên ảnh Story trước khi chia sẻ.',
    imageGenerateFailed:
      'Không thể tạo ảnh tự động. Bạn vui lòng chụp ảnh màn hình kết quả này nhé!',
    maxSelections: 'Bạn chỉ được chọn tối đa {max} lựa chọn.',
    confirmExit: 'Bạn có chắc chắn muốn thoát?',
  },

  success: {
    title: 'Hồ Sơ Đã Được Gửi Thành Công!',
    body: 'Hồ sơ của bạn đã được đưa vào Hệ thống Kín. Mọi dữ liệu tạm thời trên trình duyệt này đã được xóa sạch để đảm bảo an toàn tuyệt đối.',
    hint: 'Lần tới, bạn chỉ cần nhập',
    hintCredentials: 'Email và Mã PIN',
    hintSuffix: 'để xem lại hồ sơ này.',
    backHome: 'Quay về Trang chủ',
  },

  publicCards: {
    title: 'Bộ sưu tập thẻ card',
    subtitle: 'Tất cả thẻ quiz đã tạo của người dùng này',
    loading: 'Đang tải...',
    notFound: 'Không tìm thấy hồ sơ hoặc thẻ card.',
    backToQuiz: 'Làm quiz của bạn',
    infoTitle: 'Thông tin công khai',
    cardsTitle: 'Thẻ card đã tạo',
    cardsEmpty: 'Chưa có thẻ card nào được tạo.',
    cardsEmptyHint: 'Hoàn thành bài quiz để tạo thẻ chia sẻ đẹp mắt.',
    verified: 'Đã xác thực CCCD',
    notVerified: 'Chưa xác thực',
    roleEmpty: 'Chưa cập nhật',
    cardType: {
      personality: 'Gu khi yêu',
      single: 'Trái tim băng giá',
    },
    meta: {
      created: 'Tạo lúc',
      aspect: 'Tỉ lệ',
    },
    viewOriginal: 'Xem ảnh gốc',
    close: 'Đóng',
  },
} as const;

export type Messages = typeof viMessages;